/**
 * 公共api
 */
export default {
  SMSCode: "/userLogin/SMSCode", // 获取短信验证码
  CheckSMSCode: "/userLogin/CheckSMSCode", // 提交短信验证码
}
